import {useTouch} from "../../hooks";
import {useNavigate} from "react-router-dom";
import React from "react";

export function TextWithButtonLink({value = "", label, to, tip, disabled = false}) {
    const touch = useTouch()
    const navigate = useNavigate()

    function handleOnClick() {
        if (disabled) return;
        navigate(to);
    }

    return <div className={`text-start d-flex align-items-center justify-content-between my-2 px-1 ${disabled ? "text-muted" : "hover-bg-secondary-subtle rounded"}`}
                onClick={handleOnClick}>
        <div className="d-flex flex-column">
            <div className="text-capitalize fw-semibold">{label}</div>
            {tip && <div className={`fw-light ${touch ? "text-primary" : ""}`}>{tip}</div>}
        </div>
        <div>{touch ? value : `Manage ${value}`} <i className={touch ? "" : "bi bi-chevron-right"}/></div>
    </div>
}
